export default "/images/nuvei.png?be8398ac75ac686733f29169a1a640c6";